<template>
  <p
    class="mb-12 flex items-start gap-1 text-sm font-medium md:mb-16"
    :class="onDark ? 'text-white' : 'text-grey-900'"
  >
    <component
      :is="arrowIcon"
      class="size-4 shrink-0 fill-current"
      :class="{ 'order-2': arrowIsAfterText }"
    />
    {{ text }}
  </p>
</template>
<script setup lang="ts">
import IconArrowLeftUp from "@/components/icon/arrow/LeftUp.vue";
import IconArrowRightUp from "@/components/icon/arrow/RightUp.vue";
import IconArrowLeftDown from "@/components/icon/arrow/LeftDown.vue";
import IconArrowRightDown from "@/components/icon/arrow/RightDown.vue";

const props = defineProps<{
  text: string;
  arrowIcon:
    | "IconArrowLeftUp"
    | "IconArrowRightUp"
    | "IconArrowLeftDown"
    | "IconArrowRightDown";
  onDark?: boolean;
}>();

const arrowIcon = computed(() => {
  switch (props.arrowIcon) {
    case "IconArrowLeftUp":
      return IconArrowLeftUp;
    case "IconArrowRightUp":
      return IconArrowRightUp;
    case "IconArrowLeftDown":
      return IconArrowLeftDown;
    case "IconArrowRightDown":
      return IconArrowRightDown;
    default:
      return null;
  }
});

const arrowIsAfterText = computed(() => props.arrowIcon.includes("Right"));
</script>
